import type { IncomeSplitConfigLegacy } from '@fruitful/income-split';

import { requestBuilder } from '../../http/RequestBuilder';

const useGetProposedLegacyIncomeSplit = requestBuilder.query<
    IncomeSplitConfigLegacy,
    { membershipId: string; moneyMapId: string }
>({
    endpoint: ({ membershipId, moneyMapId }) =>
        `/api/admin/money-map/${membershipId}/${moneyMapId}/income-split-legacy`,
    queryKey: ({ membershipId, moneyMapId }) =>
        `useGetProposedLegacyIncomeSplit/${membershipId}/${moneyMapId}`,
});

export default useGetProposedLegacyIncomeSplit;
